
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WebsiteGroupRestoreBackupDtoExtended } from "@/services/Backup/interfaces";

@Component({
  mixins: [
    Themeable,
  ],
  inject: [],
})
export default class RestoreWebsiteGroupDialog extends Vue {
  @Prop() data: WebsiteGroupRestoreBackupDtoExtended;

  @Prop() mainWebsiteDomain: string;

  @Prop() public scope!: string;

  private scopeLabels = {
    'account': 'terminated backup',
    'server': 'server backup',
  };

  public visible: boolean = true;

  public loading: boolean = true;

  public async created(): Promise<void> {
    this.loading = false;
  }

  public async restoreWebsiteGroup(): Promise<void> {
    this.$emit('restoreWebsiteGroup', {
      targetBackupId: this.data.targetBackupId,
      websiteGroupId: this.data.websiteGroupId,
    });

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');

    this.visible = false;
    this.loading = true;
  }
}
